// One-click investor demo mode: automation ON TOP of the verified live path.
// It only presses "Start live demo Run" for the presenter and lets the real Run
// drive the UI hands-off to the outcome reveal — no synthetic events, no extra
// rendering path, every honesty rule of live mode applies unchanged.
export const DEMO_SCENARIOS = ["xius", "griffendo"];
export const DEMO_BASE = "/app/decision-graph/demo";

export function buildDemoPath(scenario) {
  return DEMO_SCENARIOS.includes(scenario) ? `${DEMO_BASE}/${scenario}` : null;
}

export function parseDemoParams(params) {
  const s = params?.scenario;
  return DEMO_SCENARIOS.includes(s) ? { scenario: s } : null;
}

// Auto-start exactly once, only when the picker has loaded and the signed-in
// account is actually allowed to create a Run (same gate as the button).
export function shouldAutoStart({ demo, listStatus, canCreate, alreadyStarted }) {
  return !!demo && listStatus === "ready" && canCreate === true && !alreadyStarted;
}
